// @flow
import React, { Component, Fragment } from "react";
import withStyles from "elevate-ui/withStyles";
import Close from "elevate-ui-icons/Close";
import classNames from "classnames";

type Props = {
  activeStep: string,
  classes: Object,
  handleSectionSelect: Function,
  handleFilterToggle: Function,
  steps: Array<string>,
};

type State = {
  selectedSection: string,
};

class FilterSectionTabs extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      selectedSection: props.activeStep,
    };
  }

  handleSelectChange = (e) => {
    this.setState({ selectedSection: e.target.value }, () =>
      this.props.handleSectionSelect(this.state.selectedSection)
    );
  };

  render() {
    const {
      activeStep,
      classes,
      handleSectionSelect,
      handleFilterToggle,
      steps,
    } = this.props;

    return (
      <Fragment>
        <div className={classes.root}>
          <div className={classes.tabRow}>
            {steps.map((step) => {
              return (
                <div
                  className={classNames(
                    classes.tab,
                    activeStep === step ? classes.active : null
                  )}
                  key={step}
                  onClick={() => handleSectionSelect(step)}
                >
                  {step}
                </div>
              );
            })}
          </div>
          <div className={classes.mobileSelects}>
            <select
              className={classes.select}
              value={activeStep}
              onChange={this.handleSelectChange}
            >
              {steps.map((step) => <option key={step}>{step}</option>)}
            </select>
          </div>
          <div className={classes.closeContainer}>
            <button
              onClick={handleFilterToggle}
              className={classes.closeButton}
            >
              <Close />
            </button>
          </div>
        </div>
      </Fragment>
    );
  }
}

const styles = (theme) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    flexFlow: "row nowrap",
    minHeight: 64,
    padding: "12px 0 0 24px",
    backgroundColor: theme.colors.gray["100"],
  },
  tabRow: {
    display: "none",
    flexFlow: "row nowrap",
    justifyContent: "flex-start",
    alignItems: "flex-end",
    [theme.breakpoints(769)]: {
      display: "flex",
    },
  },
  tab: {
    flex: "0 1 auto",
    borderTopLeftRadius: theme.globalBorderRadius,
    borderTopRightRadius: theme.globalBorderRadius,
    padding: 12,
    fontSize: 14,
    cursor: "default",
    "&:hover": {
      color: theme.colors.primary["500"],
    },
  },
  active: {
    extend: "tab",
    backgroundColor: theme.colors["white"],
    color: theme.colors.primary["500"],
  },
  mobileSelects: {
    display: "flex",
    [theme.breakpoints(769)]: {
      display: "none",
    },
  },
  select: {
    padding: "12px 62px 12px 12px",
    border: "none",
    backgroundColor: "#ffffff",
    backgroundImage: "url(images/ArrowDown.png)",
    backgroundSize: 16,
    backgroundPosition: "90% center",
    backgroundRepeat: "no-repeat",
    borderRadius: 0,
    borderTopLeftRadius: theme.globalBorderRadius,
    borderTopRightRadius: theme.globalBorderRadius,
    appearance: "none",
  },
  closeContainer: {
    padding: "0 8px",
  },
  closeButton: {
    width: 40,
    height: 40,
    textAlign: "center",
    appearance: "none",
  },
});

export default withStyles(styles, { name: "FilterSectionTabs" })(
  FilterSectionTabs
);
